// extracted by mini-css-extract-plugin
export default {"index":"invoices_index__YjLOJ","action-filter-buttons":"invoices_action-filter-buttons__OU0iz","separator":"invoices_separator__8dTbj"};